import { useSettings, useStore } from '../state/store'

/**
 * The playback speed for everything the app says, always visible in the rail.
 *
 * A slider beside each phrase was the obvious reading of the request, but a
 * list of five blocks would then carry five sliders that all mean the same
 * thing — and a learner who moved one would reasonably expect the others to
 * disagree. One control that governs every playback is the same capability
 * without the ambiguity, and it is reachable from every screen rather than
 * buried in Settings.
 *
 * The per-phrase “Slower” button covers the other case: pulling one line
 * apart without disturbing the pace you have settled on.
 */
export function SpeechSpeed() {
  const settings = useSettings()
  const { dispatch } = useStore()

  return (
    <div className="speed">
      <label className="speed-row">
        <span className="speed-label">Speech</span>
        <input
          className="speed-range"
          type="range"
          min={0.3}
          max={1.3}
          step={0.05}
          value={settings.speechRate}
          aria-label="Speaking speed"
          onChange={(e) =>
            dispatch({ type: 'updateSettings', patch: { speechRate: Number(e.target.value) } })
          }
        />
        <span className="speed-value">{settings.speechRate.toFixed(2)}×</span>
      </label>
    </div>
  )
}
